import * as TYPES from './mutations-types'

export default {
  [TYPES.SET_PARTNERS_LIST] (state, loadedList) {
    state.partnersList = loadedList
  }
}
